import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';

const SignIn = () => {
  const data = document.getElementById('data-react-props');
  const { omniauthPath = '' } = data?.dataset || {};

  return (
    <div className="grid h-screen grid-cols-2">
      <div className="flex flex-col justify-center items-center h-screen">
        <a href="/" className='mb-6'>
          <img src="/assets/media/logos/talk.svg" alt="talk logo" />
        </a>
        <div className='text-2xl text-carnation-500 mb-8 leading-6'>
          Sign In
        </div>
        <div className='mb-8 text-shark'>
          Welcome to TALK!
        </div>
        <a href={omniauthPath}
            target='_self'
            rel="noreferrer noopener"
            >
          <div className='w-64 mb-8 bg-linkedin hover:bg-astral-600 text-white font-bold py-2 rounded text-center flex'>
            <FontAwesomeIcon icon={faLinkedinIn} className='ml-4 h-4 w-4 mt-1 text-white align-middle' />
            <div style={{ width: "calc(100% - 64px)" }}>Sign in</div>
          </div>
        </a>
        <Link to="/sign-up">
          <div className='w-64 mb-8 bg-linkedin hover:bg-astral-600 text-white font-bold py-2 rounded text-center'>
            Sign up
          </div>
        </Link>
      </div>
      <div className="bg-carnation-500 h-screen flex flex-row">
        <div className='flex flex-col justify-center items-center flex-1'>
          <div className="mx-12">
            <h3 className='text-5xl text-white mb-8 text-center' style={{ textShadow: "1px 1px 2px rgba(82, 82, 82, 0.86)" }}>
              Your TALK Community
            </h3>
            <div className='text-white font-thin'>
              Interact with other TA/HR Professionals, attend the events/webinars, post in the forums, take polls, browse vendors, and more.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
